<div [style.min-height.%]="100" class="sidebar">
  <!-- <app-toolbar></app-toolbar>
  <mat-sidenav-container class="sidebar-container">
    <mat-sidenav mode="side" opened>
     <app-menu-sidebar></app-menu-sidebar>
    </mat-sidenav>
    
      <mat-sidenav-content>
        <app-tabs></app-tabs>    
        <router-outlet></router-outlet>
        <div class="sidebar-table">
          <app-tabla-clientes></app-tabla-clientes>
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
  </mat-sidenav-container> -->
  <app-logo [routerLink]="['inicio']"></app-logo>
  <app-user></app-user>
  <app-menu-sidebar></app-menu-sidebar>
  <!--  <app-sidebarinproeco></app-sidebarinproeco> -->
</div>
